<template>
<div class="page page_cart">
    <!-- 购物车有商品 -->
    <div class="list_wrap" v-if="dataList.length != 0 && isFinishToGetCart ? true : false">
        <div class="list" v-for="(item,index) in dataList" :key="index">
            <div class="list_top">
                <div class="select_box">
                    <van-checkbox v-model="item.checked" @click="clickShopCheck(item)">
                        <template #icon="props">
                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
                        </template>
                    </van-checkbox>
                </div>
                <div class="top_r">
                    <img :src="(item.tradesman_thumb&&item.tradesman_thumb!=undefined&&item.tradesman_thumb!='')? imageUrl+item.tradesman_thumb:$publicData.intangibleDefault" alt="" class="thumb">
                    <span class="name">{{ item.tradesman_name }}</span>
                </div>
            </div>
            <div class="list_item">
                <van-swipe-cell v-for="(goods,index) in item.goods" :key="index" class="swipeCell">
                    <div class="select_box">
                        <van-checkbox :name="goods.cart_id" v-model="goods.checked" @click="clickGoodsCheck(item,goods)">
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
                            </template>
                        </van-checkbox>
                    </div>
                    <div class="item_nr">
                        <div class="nr_l" @click="goShopDetail(goods)">
                            <img :src="(goods.good_thumb&&goods.good_thumb!=undefined&&goods.good_thumb!='')?imageUrl+goods.good_thumb:$publicData.intangibleDefault" alt="" class="thumb">
                        </div>
                        <div class="nr_r">
                            <div class="nr_r_t" @click="goShopDetail(goods)">
                                <div class="title slh_s">{{ goods.good_title }}</div>
                                <div class="sku slh_s">{{ goods.good_spec_name }}</div>
                            </div>
                            <div class="nr_r_b">
                                <div class="nr_r_b_l">
                                    <span class="price"><span class="tag_cash">¥</span>{{ goods.good_price }}</span>
                                </div>
                                <div class="nr_r_b_r">
                                    <van-stepper v-model="goods.good_nums" :name="goods.cart_id" @change="goodNumChange" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <template #right>
                        <van-button square type="danger" text="删除" @click="FunDelete(goods.cart_id)" />
                    </template>
                </van-swipe-cell>
            </div>
        </div>
        <!-- 结算 -->
        <div class="bottom tijiao">
            <div class="quanxuan" @click="clickAllCheck">
                <van-checkbox v-model="allCheck">
                    全选
                    <template #icon="props">
                        <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
                    </template>
                </van-checkbox>
            </div>
            <div class="tijiao_l">共{{totalNums}}件，合计：<span class="price"><span class="tag_cash">¥</span>{{totalCash}}</span></div>
            <div class="tijiao_r" @click="buyGoods">立即购买</div>
        </div>
    </div>
    <!-- 购物车无商品 -->
    <div class="page_success" v-if="dataList.length != 0 ? false : isFinishToGetCart">
        <div class="top">
            <img :src="this.publicPath+'statics/images/shop/nogoods.png'" alt="" class="tu">
        </div>
        <div class="tips">
            <div class="txt">暂无商品</div>
            <div class="sub_txt">再忙，也要记得买点东西犒劳自己～</div>
        </div>
        <div class="action" @click="goIndex">去逛逛</div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN,
    SETTLE
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
import { Toast } from 'vant';

export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            result: [],
            isFinishToGetCart: false,   // 是否已获取购物车
            checkedAll: false,
            activeIcon: process.env.BASE_URL + './statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + './statics/images/inactive.png',
            index: undefined,
            dataList: [],
            totalNums: 0, // 总件数
            totalCash: 0, // 总钱数
            allCheck: true,
            isClient: false,
            imageUrl: this.$publicData.uploadImage,
            // dataList: []
        }
    },
    components: {
        // PageSearch
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '购物车'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData();
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.getData();
                responseCallback('success')
            })
        } else {
            this.token = this.$store.getters.token
            // 获取商品详情
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
            var params = {
                token: this.token,
                type: 1,
            }
            console.log(params)
            this.$api.shop.shopCart(params).then(res => {
                if (res.code == 200) {
                    var list = res.result
                    for (let i = 0; i < list.length; i++) {
                        var item = list[i];
                        item.checked = true
                        for (let j = 0; j < item.goods.length; j++) {
                            var good = item.goods[j];
                            good.checked = true
                            item.goods[j] = good
                        }
                        list[i] = item
                    }
                    this.dataList = list
                    this.calculationCountAndMoney()
                } else {
                    this.$toast(res.message)
                }
                this.isFinishToGetCart = true;
            })

        },
        buyGoods() {
			var that = this;
            var cartIds = ''
            var list = this.dataList
            for (let i = 0; i < list.length; i++) {
                var shop = list[i];
                for (let j = 0; j < shop.goods.length; j++) {
                    var tempGoods = shop.goods[j];
                    if (tempGoods.checked) {
                        if (cartIds != '') {
                            cartIds += ','
                        }
                        cartIds += tempGoods.cart_id
                    }
                }
            }
            if ( cartIds == null || cartIds == undefined || cartIds == '') {
                this.$toast('请选择商品')
                return
            }
            var params = {
                token: this.token,
                cartids: cartIds,
            }
            console.log(params)
            this.$api.shop.prePay(params).then(res => {
                if (res.code == 200) {
                    that.$store.commit('REMOVEADDRESS');
                    var data = res.result
                    that.$store.commit(SETTLE, {
                        shop_settle: JSON.stringify(data)
                    });
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        // var params = {
                        //     'data': {
                        //         'key': 'settle',
                        //         'value': JSON.stringify(data)
                        //     }
                        // }
                        // that.$bridge.callhandler('sdjy://public/saveInfo', params, (data) => {
                            //跳转至结算
                            var params = {
                                'data': {
                                    'url': this.$publicData.clientUrl + '/shop/settle' + '?discount=' + res.result.discount
                                }
                            }
                            that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                            })
                        // })
                    } else if (userAgent.indexOf('MicroMessenger') != -1) {// 在微信中
                        console.log('MicroMessenger')
                        wx.miniProgram.getEnv(function(minRes) {
                            if (minRes.miniprogram) {
                                // 走在小程序的逻辑
                                Toast('请在公众号中搜索“时代记忆”进行购买')
                            } else {
                                that.$store.commit(SETTLE, {
                                    shop_settle: JSON.stringify(data)
                                });
                                that.$router.push({
                                    path: '/shop/settle',
                                    query: {
                                        discount: res.result.discount
                                    }
                                })
                            }
                        })
                        return
                    } else {
                        
                        that.$router.push({
							path: '/shop/settle',
							query: {
								discount: res.result.discount
							}
                        })
                    }
                    // this.dataList = res.result
                } else {
                    this.$toast(res.message)
                }
            })
        },
        //选择一个店的商品
        clickShopCheck(item) {
			var list = this.dataList
			// console.log('item====',item)
            for (let i = 0; i < list.length; i++) {
                var shop = list[i];
                if (shop.tradesman_id == item.tradesman_id) {
					// shop.checked = !shop.checked
                    for (let j = 0; j < item.goods.length; j++) {
                        var good = shop.goods[j];
                        good.checked = shop.checked
                        shop.goods[j] = good
                    }
					list[i] = shop
                    break
                }
            }
			this.dataList = list
			console.log('this.dataList',this.dataList)
            this.calculationCountAndMoney()
        },
        //选择购物商品
        clickGoodsCheck(item, goods) {
            var list = this.dataList
            for (let i = 0; i < list.length; i++) {
                var shop = list[i];
                if (shop.tradesman_id == item.tradesman_id) {
                    var check = false
                    for (let j = 0; j < shop.goods.length; j++) {
                        var tempGoods = shop.goods[j];
                        if (tempGoods.cart_id == goods.cart_id) {
                            // tempGoods.checked = !tempGoods.checked
                        }
                        if (tempGoods.checked) {
                            check = true
                        }
                        shop.goods[j] = tempGoods
                    }
                    shop.checked = check
                }
                list[i] = shop
            }
            this.dataList = list
            this.calculationCountAndMoney()
        },
        //全选
        clickAllCheck() {
            console.log(this.allCheck)
            var check = true
            if (this.allCheck) {
                check = false
            }
            var list = this.dataList
            for (let i = 0; i < list.length; i++) {
                var shop = list[i];
                for (let j = 0; j < shop.goods.length; j++) {
                    var tempGoods = shop.goods[j];
                    tempGoods.checked = check
                    shop.goods[j] = tempGoods
                }
                shop.checked = check
                list[i] = shop
            }
            this.dataList = list
            this.calculationCountAndMoney()
        },
        //计算价格数量
        calculationCountAndMoney() {
            var allCount = 0
            var allPrice = 0
            var allCheck = true
            var list = this.dataList
            for (let i = 0; i < list.length; i++) {
                var shop = list[i];
                for (let j = 0; j < shop.goods.length; j++) {
                    var tempGoods = shop.goods[j];
                    if (tempGoods.checked) {
                        allCount += tempGoods.good_nums
                        allPrice += (tempGoods.good_nums * tempGoods.good_price)
                    } else {
                        allCheck = false
                    }
                }
            }
            this.totalNums = allCount
            this.totalCash = allPrice
            this.allCheck = allCheck
        },
        // 删除
        FunDelete(id) {
            console.log('删除', id)
            var params = {
                token: this.token,
                cart_id: id,
            }
            this.$api.shop.delectCart(params).then(res => {
                if (res.code == 200) {
                    this.getData()
                    this.$toast('删除成功')
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 无商品 再去逛逛
        goIndex() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                })

            } else {
                this.$router.push({
                    name: 'shop'
                })
            }

        },
        goodNumChange(value, detail) {
            console.log('goodNumChange')
            var cart_id = detail.name
            var params = {
                token: this.token,
                cart_id: cart_id,
                num: value
            }
            this.$api.shop.addGoodsNum(params).then(res => {
                if (res.code == 200) {
                    var data = res.result
                    var list = this.dataList
                    for (let i = 0; i < list.length; i++) {
                        var item = list[i];
                        for (let j = 0; j < item.goods.length; j++) {
                            var good = item.goods[j];
                            if (good.cart_id == cart_id) {
                                good.good_nums = value
                            }
                            item.goods[j] = good
                        }
                        list[i] = item
                    }
                    this.dataList = list
                    this.calculationCountAndMoney()
                } else {
                    this.dataList = this.dataList
                    this.$toast(res.message)
                }
            })

        },
        // 商品详情
        goShopDetail(goods) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?goodsId=" + goods.good_id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/shop/detail" + p
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.$router.push({
                    path: "/shop/detail",
                    query: {
                        goodsId: goods.good_id,
                    },
                });
            }
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
